import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        padding: theme.spacing(1),
        //Custom Styles AP
        backgroundColor: '#333333',
        height: '100vh'
    },
});

